import { render, staticRenderFns } from "./reworkHome.vue?vue&type=template&id=13f07afc&scoped=true&"
import script from "./reworkHome.vue?vue&type=script&lang=js&"
export * from "./reworkHome.vue?vue&type=script&lang=js&"
import style0 from "./reworkHome.vue?vue&type=style&index=0&id=13f07afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f07afc",
  null
  
)

export default component.exports